import React, { useCallback, useEffect, useState } from 'react';
import { Box, Typography, IconButton, Grid2, Button } from '@mui/material';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// import AppModal from '../Modal/AppModal';
import { toast, Toaster } from "react-hot-toast";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ReusableDrawer from '../CheckoutSidebar/ReusableDrawer';
import SidebarNav from '../CheckoutSidebar/SidebarNav';
import SidebarForm from '../CheckoutSidebar/SidebarForm';
// import TabPanel from '../CheckoutSidebar/TabPanel';
import { useWindowResize } from '../../hooks/useWindowResize';
import { useGet } from '../../hooks/useApi';
// import { handleAddToFavorite } from '../../services/api';

import { useAddGiftFavorite } from '../../hooks/useAddGiftFavorite';
// import CourseForm from '../CheckoutSidebar/CourseForm';



// Reusable ProductDetails Component
// eslint-disable-next-line no-empty-pattern
const ItemDetails = ({buttontext, detail,position = "same-line",category_title="", items, item_details = [{ label: '', value: ''}]}) => {

  const [selectedImage, setSelectedImage] = useState(0); // Index of the selected image
  // const [showModal, setShowModal] = useState(false)
  // const {pathname} = useLocation();

  // const [giftId, setGiftId] = useState('');
  // const [twindowWidth, setWindowWidth] = useState(window.innerWidth);
  const [openGiftDrawer, setOpenGiftDrawer] = useState(false);

  const [drawerType, setDrawerType] = useState(null); 
  
  const [isButtonDisabled, setIsButtonDisabled] = useState(false); 

  const [giftfavorites, setGiftFavorites] = useState([]);

  // const [previousPath, setPreviousPath] = useState(null);
  const location = useLocation();
  const { id } = useParams(); 
  const customerId = sessionStorage.getItem("userId"); 
  // const userEmail = sessionStorage.getItem("userEmail");
  
const { data: getGiftFavorite} = useGet(`/api/GiftItems/favorites/${customerId}`);
const favoriteGiftCard = getGiftFavorite?.data
console.log('gift',favoriteGiftCard);


  
 

  const {addGiftToFavorite} = useAddGiftFavorite();



// Set favorites when API data changes

useEffect(() => {
  if (favoriteGiftCard) {
    setGiftFavorites(favoriteGiftCard);
  }
}, [favoriteGiftCard]);





//   const handleAddCourseToFavorite = async (id) => {
//     console.log('add',courseFavorites?.some(favorite => Number(favorite.courseId) === Number(id)));
// console.log(courseFavorites?.courseId);
//     // Check if already in favorites using API data
//   if (courseFavorites?.some(favorite => favorite.courseId === id)) {
//     toast.error('Already in favorites!', {
//       position: "top-right"
//     });
//     return;
//   }

//     try {
//       // Add to favorites
//       await addToFavorite(id, customerId);
//       setCourseFavorites([...courseFavorites, id]);
      
//       // Store in localStorage
//       const updatedFavorites = [...courseFavorites, id];
//       localStorage.setItem('courseFavorites', JSON.stringify(updatedFavorites));
      
//       toast.success('Added to favorites successfully!', {
//         position: "top-right"
//       });
//     } catch (err) {
//       toast.error('Failed to add to favorites', {
//         position: "top-right"
//       });
//     }
//   };
  // const handleAddCourseToFavorite = async (id)=>{

  //   if (courseFavorites.includes(id)) {
  //     toast.error('Already in favorites!', {
  //       position: "top-right"
  //     });
  //     return;
  //   }

  
  //   try {
  //     await addToFavorite(id, customerId);
  //     setCourseFavorites([...courseFavorites, id]);
  //     // Show success message or update UI
  //     toast.success('Added to favorites successfully!', {
  //       position: "top-right"
  //     });
  //   } catch (err) {
  //     // Handle error in UI
  //     toast.error('Failed to add to favorites:', err, {
  //       position: "top-right"
  //     });
  //   }
 

    
   
  // }
  const handleAddGiftToFavorite = async (id)=>{
   
  
  
    const isAlreadyFavorite = giftfavorites?.some(
      favorite => Number(favorite.id) === Number(id)
    );
  
  
    if (isAlreadyFavorite) {
      toast.error('Already in favorites!', {
        position: "top-right"
      });
      return;
    }
    try {
      await addGiftToFavorite(id, customerId);
      setGiftFavorites([...giftfavorites, id]);
      // Show success message or update UI
      toast.success('Added to favorites successfully!', {
        position: "top-right"
      });
    } catch (err) {
      // Handle error in UI
      console.error(err)
      toast.error('Failed to add to favorites', {
        position: "top-right"
      });
    }

    
   
  }
 
  const navigate = useNavigate(); // Used for navigation on mobile
  const [previousPath, setPreviousPath] = useState(null);
  const MOBILE_BREAKPOINT = 768;
  
  const handleBreakpointChange = useCallback((newBreakpoint, width) => {
    // Ensure width is a number
    const numericWidth = typeof width === 'number' ? width : window.innerWidth;
    
    console.log('Breakpoint changed:', {
      newBreakpoint,
      width: numericWidth,
      isMobile: numericWidth < MOBILE_BREAKPOINT,
      currentPath: location.pathname
    });

    const isCheckoutGiftForm = location.pathname === '/product/gift-details/checkout-form';
    const isGiftDetails = location.pathname === `/product/gift-details/${id}`;

    // Debug log before navigation
    console.log('Navigation check:', {
      newBreakpoint,
      isCheckoutGiftForm,
      isGiftDetails,
      shouldNavigateToGiftCheckout: newBreakpoint === 'mobile' && isCheckoutGiftForm,
      shouldNavigateToGiftDetails: newBreakpoint === 'desktop' && isGiftDetails
    });

    if (newBreakpoint === 'mobile' && isGiftDetails) {
      console.log('Navigating to checkout form');
      navigate(`/product/gift-details/${id}`);
    } else if (newBreakpoint === 'desktop' && isCheckoutGiftForm) {
      console.log('Navigating to gift details');
      navigate(`/product/gift-details/${id}`);
    }
  }, [location.pathname, id, navigate]);

  const { windowWidth, isMobile, breakpoint } = useWindowResize(handleBreakpointChange);


  // Debug effect to monitor state changes
  useEffect(() => {
    // console.log('State updated:', {
    //   windowWidth,
    //   isMobile,
    //   breakpoint,
    //   currentPath: previousPath,
    //   actualWidth: window.innerWidth,
    //   actualIsMobile: window.innerWidth < MOBILE_BREAKPOINT
    // });
  }, [windowWidth, isMobile, breakpoint, location.pathname,previousPath]);
 
  useEffect(() => {
    setPreviousPath(location.pathname);
  }, [location.pathname]);

  // Your existing handleCheckoutCourse function



  const handleCheckoutGift = () => {
    if (isButtonDisabled) return; // Prevent function execution if the button is disabled
  
    setIsButtonDisabled(true); // Disable the button to prevent double-clicks
    setDrawerType('gift');
    setOpenGiftDrawer(true);
  
    // Navigate after state change is applied
    if (location.pathname === '/product/gift-details/checkout-form') {
      setOpenGiftDrawer(true);
      if (!isMobile) {
        navigate(`/product/gift-details/${id}`);
      }
    }
  
    // On gift details page
    if (location.pathname === `/product/gift-details/${id}`) {
      setOpenGiftDrawer(true);
      if (isMobile) {
        navigate(`/product/gift-details/checkout-form?productId=${id}`);
      }
    }
  
    // Re-enable the button after the navigation is completed
    // You can remove the timeout here if you want it to immediately respond once the action is completed
    setTimeout(() => {
      setIsButtonDisabled(false); // Re-enable the button after the action is complete
    }, 2000); // Adjust this time if needed to allow time for navigation to complete
  };
  
  


  const handleDrawerGiftClose = () => {
    setOpenGiftDrawer(false);
    setDrawerType(null);
  };
 


  // Handle thumbnail click
  const handleThumbnailClick = (index) => {
    setSelectedImage(index);
  };

  
  // Handle next image
const handleNextImage = () => {
  if (items?.images?.length > 0) {
    setSelectedImage((prev) => (prev + 1) % items.images.length); // Cycle through images
  }
};

// Handle previous image
const handlePrevImage = () => {
  if (items?.images?.length > 0) {
    setSelectedImage((prev) => (prev - 1 + items.images.length) % items.images.length); // Cycle through images
  }
};




  // const positionStyles = position === "same-line"
  // ? { display: "flex", justifyContent: "space-between", alignItems: "center" } // Same line
  // : { position: "absolute", top: "10px", left: {md:"15px", xs:'0px'}, right: "0", display: "flex", justifyContent: "space-between", alignItems: "center"}; // Top
  


  return (
    <Box sx={{ display: 'flex', flexDirection: { md: 'row', xs: 'column' }, gap: 4, padding: { md: 2, xs: 1 }, fontFamily: theme => theme.typography.smallText }}>
      {/* Main Image Section */}
      <Box sx={{ position: 'relative', flex: 1, width: { xs: "100%", md: '50%' } }}>
      <Box sx={{ position: 'relative', padding: 3, backgroundColor: '#f9f9f9', borderRadius: 4 }}>
  {/* Arrow buttons */}
  <IconButton
    sx={{
      position: 'absolute',
      top: '50%',
      left: 30,
      transform: 'translateY(-50%)',
      backgroundColor: '#EEE6FE',
      borderRadius: '50%',
      zIndex: 1, // ensure button is above the image
      '&:hover': {
        color: '#fff',
        backgroundColor: (theme) => theme.palette.secondary.main,
        '& svg': {
          fill: '#fff',
        },
      },
    }}
    onClick={handlePrevImage}
  >
    <ChevronLeftIcon
      sx={{
        fill: '#5604F6',
        transition: 'fill 0.3s ease',
        '&:hover': {
          fill: '#fff',
        },
      }}
    />
  </IconButton>

  {/* Image with padding */}
  <Box sx={{ padding: 2 }}>
    <img
      src={items?.images?.[selectedImage]?.imagepath}
      alt={items?.name}
      style={{
        width: '100%',
        height: '450px',
        borderRadius: 8,
        objectFit: 'cover',
      }}
    />
  </Box>

  <IconButton
    sx={{
      position: 'absolute',
      top: '50%',
      right: 30,
      transform: 'translateY(-50%)',
      backgroundColor: '#EEE6FE',
      borderRadius: '50%',
      zIndex: 1, // ensure button is above the image
      '&:hover': {
        color: '#fff',
        backgroundColor: (theme) => theme.palette.secondary.main,
        '& svg': {
          fill: '#fff',
        },
      },
    }}
    onClick={handleNextImage}
  >
    <ChevronRightIcon
      sx={{
        fill: '#5604F6',
        transition: 'fill 0.3s ease',
        '&:hover': {
          fill: '#fff',
        },
      }}
    />
  </IconButton>
</Box>

  
        {/* Thumbnail Images */}
        <Grid2 container spacing={2} justifyContent={'space-between'} sx={{ marginTop: 4 }}>
        {items?.images?.map((image, index) => (
            <Grid2 item xs={4} key={image?.id} size={{ xs: 4, md: 4 }}>
              <img
                src={image?.imagepath}
                alt={`Thumbnail ${image?.id + 1}`}
                loading="lazy"
                style={{
                  cursor: 'pointer',
                  width: '100%',
                  height: '100%',
                  borderRadius: 8,
                  border: selectedImage === index ? '2px solid #5604F6' : 'none',
                }}
                onClick={() => handleThumbnailClick(index)}
              />
            </Grid2>
          ))}
        </Grid2>
  
      </Box>
  
      {/* Product Details Section */}
      <Box position='relative' sx={{ flex: 1, display: 'flex', flexDirection: 'column', borderRadius: '15px', backgroundColor: '#fff', padding: { md: 4, xs: 1 } }}>
        {items?.manufacturer && (
          <Typography
            sx={{
              backgroundColor: 'rgba(246, 167, 4, 1)',
              borderRadius: '8px',
              px: 1,
              textTransform: 'uppercase',
              width: 'fit-content',
              height: 30,
              gap: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              my: { md: 2, xs: 1 },
            }}
          >
            {items.manufacturer?.image && (
              <img
                src={items?.manufacturer?.image}
                alt="Category img"
                style={{ borderRadius: '50%', width: 16, height: 16 }}
              />
            )}
            {items.manufacturer?.name}
          </Typography>
        )}
        <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#5604F6', marginTop: 6 }}>
          {items?.name}
        </Typography>
        <Typography variant="body1" sx={{ marginTop: 1 }}>
          {items?.longDescription}
        </Typography>
  
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 4 }}>
          <Typography variant="body1" sx={{ margin: 1 }}>
            {category_title}
          </Typography>
  
          {items?.catgoryName && (
            <Typography
              sx={{
                backgroundColor: 'rgba(246, 167, 4, 1)',
                borderRadius: '8px',
                px: 1,
                textTransform: 'uppercase',
                width: 'fit-content',
                height: 'auto',
                gap: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: { md: 2, xs: 1 }
              }}
            >
              {items?.category_image && (
                <img
                  src={items?.category_image}
                  alt="Category img"
                  style={{ borderRadius: '50%', width: 16, height: 16 }}
                />
              )}
              {items?.catgoryName}
            </Typography>
          )}
        </Box>
  
        <Box sx={{ display: 'flex', flexDirection: 'column', backgroundColor: '#E7E7E733', borderRadius: '10px', padding: { md: 2, xs: 1 }, marginTop: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 1 }}>
            <Typography variant="h6" sx={{ color: theme => theme.palette.primary.main, fontSize: 20 }}>
              ₦ {items?.price}
            </Typography>
            <Typography variant="p" sx={{ color: '#12121299', fontSize: 12 }}>
              (Per Unit)
            </Typography>
          </Box>
        </Box>
  
        <Box sx={{ border: '1px solid #D2D1D6', borderRadius: '10px', padding: 2, marginTop: 4 }}>
          <Typography variant="body2" sx={{ marginTop: 1 }}>
            {detail}
          </Typography>
  
          {/* Dynamically render gift details */}
          {item_details.map((item, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderBottom: index < item_details.length - 1 ? '1px solid #D2D1D6' : 'none', // Conditionally add border
                marginTop: 1,
                paddingBottom: 0.5
              }}
            >
              <Typography variant="p" sx={{ color: '#121212CC', fontSize: 16 }}>
                {item.label}
              </Typography>
              <Typography variant="p" sx={{ color: '#121212CC', fontSize: 16, textTransform: 'capitalize', fontWeight: '600' }}>
                {item.value}
              </Typography>
            </Box>
          ))}
        </Box>
  
        {/* Add to Favorites Button */}
        <Box sx={{ 
  display: 'flex', 
  flex: 1, 
  alignItems: 'center', 
  justifyContent: 'space-between', 
  marginTop: { md: 4, xs: 2 },
  marginBottom: { md: 0, xs: 2 }
}}>
  
  {/* Add to Favorite Button */}
  <Box sx={{ marginTop: 2, width: 'auto' }}>
    <Button
      variant="contained"
      onClick={() => handleAddGiftToFavorite(id)}
      color="secondary"
      sx={{
        width: '100%',
        padding: { md: '10px 20px', xs: '5px 8px' },
        borderRadius: '25px',
        textTransform: 'capitalize',
        backgroundColor: '#F1F0F2',
        color: '#6E6B7B',
      }}
    >
      {buttontext}
    </Button>
  </Box>

  {/* Order Now Button */}
  <Box sx={{ marginTop: 2, width: 145 }}>
    <Button
      variant="contained"
      color="success"
      onClick={handleCheckoutGift}
      sx={{
        width: '100%',
        padding: { md: '10px 20px', xs: '5px 8px' },
        borderRadius: '25px',
        textTransform: 'capitalize',
        backgroundColor: '#5604F6',
        color: '#fff'
      }}
    >
      Order Now
    </Button>
  </Box>

</Box>

        <Toaster />
    {/* Drawer for desktop */}
  
  {/* {showModal && <AppModal setShowModal={setShowModal} showModal={showModal}/>} */}
      {/* <CheckoutSidebar state={open} onClose={handleDrawerClose}/> */}
      <ReusableDrawer
      state={openGiftDrawer}
      drawerType={drawerType}
      onClose={handleDrawerGiftClose}
      SidebarContent={SidebarNav}
      FormContent={SidebarForm}
      item_details={item_details.value}
      setOnClose={setOpenGiftDrawer}
      title="Checkout"
      subtitle="Provide the recipient's details to proceed with your checkout seamlessly."
      width="35%"
    />
      </Box>
    </Box>
  );
  
};

export default ItemDetails;
